import { Entity, Field } from "typegraph";
import SubscriptionTag from "./SubscriptionTag";

@Entity({one: "subscriptionUser", many: "subscriptionsUser"})
export default class Subscription {

	@Field({entity: SubscriptionTag})
	public tags: SubscriptionTag[]

}



// WEBPACK FOOTER //
// ./src/panels/subscriptionTags/entities/Subscription.ts